<template>
  <el-popover
    v-model="showPopover"
    placement="right"
    title=""
    width="280"
    trigger="manual"
  >
    <el-input
      slot="reference"
      show-password
      v-model="innerValue"
      :placeholder="$t('account.passwordPlaceholder')"
      @focus="showPopover = true"
      @blur="showPopover = false"
      @input="handleInput"
    ></el-input>
    <section>
      <p :style="{ color: config.color }">强度：{{ config.text }}</p>
      <el-progress class="progress" :percentage="config.percent" :show-text="false" :color="config.color"></el-progress>
      <p>请至少输入6个字符。请不要使用容易被猜到的密码</p>
    </section>
  </el-popover>
</template>

<script>
const passwordConfigMap = {
  weak: {
    color: '#f56c6c',
    percent: 30,
    text: '弱'
  },
  medium: {
    color: '#e6a23c',
    percent: 60,
    text: '中等'
  },
  safe: {
    color: '#67c23a',
    percent: 100,
    text: '安全'
  }
}

export default {
  name: 'PasswordInput',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      passwordConfigMap,

      showPopover: false,
      innerValue: '',
      strongPercent: 0,
      strongText: '',
      safeRank: 'weak'
    }
  },
  computed: {
    config() {
      return passwordConfigMap[this.safeRank]
    },
  },
  watch: {
    value(val) {
      this.innerValue = val
    },
    innerValue(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    /**
     * 验证密码强度
     * 1. 如果仅使用同一类数值(比如纯数字或纯字母)或位数小于6位，则提示密码强度过低
     * 2. 如密码使用两类数值及以上且位数大于6位，则提示密码强度安全
     * 3. 其他提示密码强度中等
     */
    validatePass(password) {
      const hasWord = /[a-zA-Z]+/.test(password)
      const hasNumber = /[0-9]+/.test(password)
      // 测试是否包含常见的特殊字符
      const hasSpecial = /[`~!@#$%^&*()_+<>?:"{},./;'[\]]/im.test(password)

      if (password.length <= 6) {
        return 'weak'
      } else if (password.length > 6 && hasWord && hasNumber && hasSpecial) {
        return 'safe'
      }

      return 'medium'
    },

    handleInput() {
      this.safeRank = this.validatePass(this.innerValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.progress {
  margin-top: 10px;
  margin-bottom: 20px;
}
</style>
